<template>
  <div class="h-full overflow-y-auto">
    <!-- 表格头部 -->
    <div class="sticky top-0 bg-white dark:bg-gray-800 z-10 border-b border-gray-200 dark:border-gray-700">
      <div class="flex min-w-full">
        <div class="w-[8%] py-3.5 px-3 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">ID</div>
        <div class="w-[15%] px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">分类代码</div>
        <div class="w-[20%] px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">分类名称</div>
        <div class="w-[30%] px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">描述</div>
        <div class="w-[10%] px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">排序</div>
        <div class="w-[17%] px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-gray-100">操作</div>
      </div>
    </div>

    <!-- 表格内容 -->
    <div class="divide-y divide-gray-200 dark:divide-gray-700">
      <div
        v-for="category in categories"
        :key="category.id"
        class="flex items-center min-w-full hover:bg-indigo-50 dark:hover:bg-indigo-900/30 transition-colors duration-150"
      >
        <div class="w-[8%] py-4 px-3 text-sm text-gray-900 dark:text-gray-100">{{ category.id }}</div>
        <div class="w-[15%] px-3 py-4 text-sm">
          <code class="px-2 py-1 bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-300 rounded text-xs font-mono">
            {{ category.categoryCode }}
          </code>
        </div>
        <div class="w-[20%] px-3 py-4 text-sm text-gray-900 dark:text-gray-100 font-medium">{{ displayLocalizedText(category.name) }}</div>
        <div class="w-[30%] px-3 py-4 text-sm text-gray-600 dark:text-gray-400">
          {{ displayLocalizedText(category.description) || '-' }}
        </div>
        <div class="w-[10%] px-3 py-4 text-sm text-gray-600 dark:text-gray-400">{{ category.displayOrder }}</div>
        <div class="w-[17%] px-3 py-4 text-sm">
          <div class="flex gap-2">
            <button
              @click.stop="handleEdit(category)"
              class="link-btn-edit font-medium"
            >
              编辑
            </button>
            <button
              @click.stop="handleDelete(category)"
              class="link-btn-delete font-medium"
            >
              删除
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 空状态 -->
    <div v-if="categories.length === 0" class="text-center py-12">
      <svg
        class="mx-auto h-12 w-12 text-gray-400 dark:text-gray-500"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
        />
      </svg>
      <h3 class="mt-2 text-sm font-medium text-gray-900 dark:text-gray-100">暂无套餐分类</h3>
      <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">开始创建第一个套餐分类吧</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PlanCategory } from '@/types/membership/category'
import { displayLocalizedText } from '@/types/membership/localized'

/**
 * Props
 */
interface Props {
  /** 套餐分类列表 */
  categories: PlanCategory[]
}

defineProps<Props>()

/**
 * Emits
 */
const emit = defineEmits<{
  /** 编辑分类 */
  edit: [category: PlanCategory]
  /** 删除分类 */
  delete: [category: PlanCategory]
}>()

/**
 * 处理编辑
 */
const handleEdit = (category: PlanCategory) => {
  emit('edit', category)
}

/**
 * 处理删除
 */
const handleDelete = (category: PlanCategory) => {
  emit('delete', category)
}
</script>

<style scoped>
/* 可选：添加自定义样式 */
</style>
